//External
import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import dynamic from "next/dynamic";
//Internal
import BrandVehicle from "../brandvehicle";
import Features from "../features";
const DynamicLazyGoogleReviews = dynamic(() => import("../googleReviews"));
import {
  clearVehicleList,
  setVehicleList,
  setVehicleMetaData,
  setVehicleTotalRecord,
} from "../../store/actions";
import {
  IS_WEBP_LOADED,
  getBannerCategoryClassOfTitlePosition,
  setBrandCategoryListAsUserBehaviour,
  get_cookie,
} from "utils";
import * as deviceObj from "react-device-detect";
import falconWhiteImage from "../../public/assets/images/Falcon_wordmark_white.svg";
import falconBlackImage from "../../public/assets/images/Falcon_wordmark_black.svg";

/*******************
  @Purpose : used for category
  @Parameter : { currentLocationId,categoryBannerInfo,categoryVehiclesData,features,slug1,slug2,slug3}
  @Author : INIC
  *******************/
const Category = ({
  currentLocationId,
  categoryBannerInfo,
  categoryVehiclesData,
  features,
  slug1,
  slug2,
  slug3,
}) => {
  const img = categoryBannerInfo.bottom_content_img?.jpeg_w1920;
  const dispatch = useDispatch();
  const [show, toggleClass] = useState(false);
  const [webpImg, setWebpImg] = useState("");
  const [jpegImg, setJpegImg] = useState("");
  const [titlePart1, setTitlePart1] = useState();
  const [titlePart2, setTitlePart2] = useState();
  const [textLen, setTextLen] = useState(1100);
  const [isMobile, setIsMobile] = useState(false);
  const [overlay, setOverlay] = useState("");
  // set youtube video url
  const [youtubeUrl, setYoutubeUrl] = useState("");
  const [isMobileScreen, setIsMobileScreen] = useState(false);
  const [isMobileApp, setIsMobileApp] = useState();

  // set categoryVehicle data in state which get from server side props
  useEffect(() => {
    dispatch(clearVehicleList(""));
    dispatch(setVehicleList(categoryVehiclesData?.data));
    dispatch(setVehicleMetaData(categoryVehiclesData));
    dispatch(setVehicleTotalRecord(categoryVehiclesData?.meta?.total));
  }, [slug3]);

  useEffect(() => {
    if (window.screen.width > 1024) {
      setWebpImg(categoryBannerInfo?.image?.webp_w1920);
      setJpegImg(categoryBannerInfo?.image?.jpeg_w1920);
      setIsMobile(false);
    } else {
      setWebpImg(categoryBannerInfo?.mobile_image?.webp_w1200);
      setJpegImg(categoryBannerInfo?.mobile_image?.jpeg_w1200);
      setIsMobile(true);
    }

    let str;
    let len;
    let firstPart = [];
    let secondPart = [];
    str = categoryBannerInfo?.bottom_title?.split(" ");
    len = str?.length;
    if (categoryBannerInfo?.bottom_title?.toLowerCase()?.includes("miami")) {
      for (let i = 0; i < len - 1; i++) {
        firstPart?.push(str[i]);
      }
      secondPart?.push(str[len - 1]);
    } else {
      for (let i = 0; i < len - 2; i++) {
        firstPart?.push(str?.[i]);
      }
      secondPart?.push(str?.[len - 2]);
      secondPart?.push(str?.[len - 1]);
    }
    setTitlePart1(firstPart?.join(" "));
    setTitlePart2(secondPart?.join(" "));

    let url = "";
    const urlStr = categoryBannerInfo?.bottom_mobile_video_url;
    const code = urlStr ? urlStr?.split("/")?.pop() : null;
    if (code) {
      url = "https://www.youtube.com/embed/" + code;
      setYoutubeUrl(url);
      if (window.screen.width > 767) {
        setTextLen(720);
      } else {
        // for mobile
        setTextLen(420);
      }
    } else {
      // if youtube url is not there
      setYoutubeUrl("");
      if (window.screen.width > 767) {
        setTextLen(350);
      } else {
        // for mobile
        setTextLen(420);
      }
    }
    // Set category list as user behaviour logic start here
    setBrandCategoryListAsUserBehaviour(
      categoryBannerInfo?.category_detail?.slug,
      "category"
    );
    // Set category list as user behaviour logic start here

    if (window.screen.width > 740) {
      setIsMobileScreen(false);
    } else {
      setIsMobileScreen(true);
    }

    setTimeout(() => {
      const video = document.getElementById("mobileVideoId");
      if (video) {
        video.setAttribute("playsinline", "");
        video.setAttribute("webkit-playsinline", "");
      }
    }, 200);
  }, [categoryBannerInfo]);

  // used for setOverlay for mobile and web
  const overlaySetHandler = () => {
    if (deviceObj.isMobile || deviceObj.isIOS) {
      setOverlay(
        categoryBannerInfo?.mobile_banner_overlay === 1 ? "banner-overlay" : ""
      );
    } else {
      setOverlay(
        categoryBannerInfo?.desktop_banner_overlay === 1 ? "banner-overlay" : ""
      );
    }
  };

  useEffect(() => {
    overlaySetHandler();
    setIsMobileApp(get_cookie("is_mobile_app"));
  }, []);

  /*******************
  @purpose : Render HTML/ React Components
  @Author : INIC
  ******************/
  return (
    <>
      {/* Category banner : Start */}
      {isMobileApp !== "yes" && (
        <section className={`category-banner ${overlay}`}>
          <picture className="banner-img">
            {IS_WEBP_LOADED && (
              <>
                <source
                  srcSet={webpImg}
                  alt={categoryBannerInfo.title}
                  type="image/webp"
                  width={"100%"}
                  height={"618px"}
                  className="object-cover"
                />
                <source
                  srcSet={jpegImg}
                  alt={categoryBannerInfo.title}
                  type="image/jpg"
                  width={"100%"}
                  height={"618px"}
                  className="object-cover"
                ></source>
              </>
            )}
            <img
              src={jpegImg}
              width={"100%"}
              height={"618px"}
              className="object-cover"
              alt={categoryBannerInfo.title}
            />
          </picture>
          {/* Banner Content: Start */}
          <div
            className={getBannerCategoryClassOfTitlePosition(
              isMobile
                ? categoryBannerInfo?.mobile_title_position
                : categoryBannerInfo?.title_position
            )}
          >
            {/* <div className="caption-wrap text-center">
            <span className="d-block text-white sub-title fw-regular ff-poppins">
              Falcon Car Rental
            </span>
            <span className="text-white fw-regular loc-heading ff-poppins">
              Beverly Hills · Miami Beach · Est. 2015
            </span>
          </div> */}
            <div className="caption-wrap text-center">
              <div className="banner-logo-img">
                <img
                  // src={CDN_PATH + "/logo.png"}
                  src={
                    deviceObj.isMobile || deviceObj.isIOS
                      ? categoryBannerInfo?.mobile_banner_logo === "white"
                        ? falconWhiteImage
                        : falconBlackImage
                      : categoryBannerInfo?.desktop_banner_logo === "white"
                        ? falconWhiteImage
                        : falconBlackImage
                  }
                  height={56}
                  width={455}
                  objectFit="contain"
                  title="Falcon car rental"
                  alt="Falcon car rental"
                />
              </div>
            </div>
          </div>
          {/* Banner Content: End */}
        </section>
      )}
      {/* Category banner : End */}

      <BrandVehicle
        brandCategorydetail={categoryBannerInfo.category_detail}
        slug1={slug1}
        slug2={slug2}
        slug3={slug3}
        currentLocationId={currentLocationId}
        whichPage="category"
        brandBannerInfo={categoryBannerInfo}
      />

      {/* Section Divider  */}
      <div className="custom-container">
        <div className="section-divider wb-section"></div>
      </div>
      {isMobileApp !== "yes" && <Features features={features} />}
      {/* Section Divider  */}
      <div className="custom-container">
        <div className="section-divider wb-section"></div>
      </div>

      {categoryBannerInfo?.bottom_content && (
        <section className="exotic-car border-n-mb py-75 exotic-car-details mb-4 mb-sm-0">
          <div className="custom-container">
            <div
              className={`exotic-wrapper position-relative ${show ? "active" : ""
                }`}
            >
              {categoryBannerInfo?.desktop_video &&
                !isMobileScreen &&
                categoryBannerInfo?.desktop_video_thumbnail && (
                  <div className="exotic-video">
                    <div className="video-wrap">
                      <video
                        width="320"
                        height="240"
                        poster={categoryBannerInfo?.desktop_video_thumbnail}
                        controls
                      >
                        <source
                          src={categoryBannerInfo?.desktop_video}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </div>
                )}
              {categoryBannerInfo?.mobile_video &&
                isMobileScreen &&
                categoryBannerInfo?.mobile_video_thumbnail && (
                  <div className="exotic-video">
                    <div className="video-wrap">
                      <video
                        id="mobileVideoId"
                        width="320"
                        height="240"
                        poster={categoryBannerInfo?.mobile_video_thumbnail}
                        controls
                      >
                        <source
                          src={categoryBannerInfo?.mobile_video}
                          type="video/mp4"
                        />
                      </video>
                    </div>
                  </div>
                )}
              {/* Mobile heading */}
              {isMobileApp !== "yes" && (
                <>
                  <div className="exotic-heading mb-3 mw-100 w-100 d-block d-sm-none sm-exotic-heading">
                    <h2 className="mb-0 d-flex flex-wrap">
                      <span className="mr-2">{titlePart1}</span>
                      <span>{titlePart2}</span>
                    </h2>
                  </div>

                  {/* {youtubeUrl && (
                <div className="exotic-video w-auto mb-3 mb-sm-0">
                  <div className="video-wrap">
                    <iframe
                      className="short-video"
                      width="500"
                      height="532"
                      src={youtubeUrl}
                      title=""
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    ></iframe>
                  </div>
                </div>
              )} */}
                  {categoryBannerInfo && categoryBannerInfo?.bottom_content && (
                    <div
                      className={`exotic-content overflow-hidden ${!isMobile && !categoryBannerInfo?.desktop_video
                        ? "without-youtube-web"
                        : ""
                        }`}
                    >
                      <div className="exotic-heading mt-3 mt-sm-0 mw-100 w-100 d-none d-sm-block">
                        <h2 className="mb-0 d-flex flex-wrap">
                          <span className="mr-2">{titlePart1}</span>
                          <span>{titlePart2}</span>
                        </h2>
                      </div>

                      {show ? (
                        ReactHtmlParser(categoryBannerInfo?.bottom_content)
                      ) : (
                        <>
                          {ReactHtmlParser(
                            categoryBannerInfo?.bottom_content?.substring(
                              0,
                              textLen
                            ) + "<span>...</span>"
                          )}
                        </>
                      )}
                    </div>
                  )}

                  <Button
                    variant="link"
                    className="read-more border-0 bg-transparent text-primary"
                    onClick={() => toggleClass(true)}
                  >
                    Read more <span className="icon icon-chevron-right"></span>
                  </Button>
                  <Button
                    variant="link"
                    className="read-more read-less border-0 bg-transparent text-primary"
                    onClick={() => toggleClass(false)}
                  >
                    Read less <span className="icon icon-chevron-right"></span>
                  </Button>
                </>
              )}
            </div>
          </div>
        </section>
      )}

      {categoryBannerInfo?.google_reviews?.length > 0 && isMobileApp !== "yes" && (
        <DynamicLazyGoogleReviews data={categoryBannerInfo.google_reviews} />
      )}
      {/* Section Divider  */}
      <div className="custom-container">
        <div className="dth-mg">
          <div className="thick-devide mb-0 dth-mg-child"></div>
        </div>
      </div>
    </>
  );
};

export default Category;
